import { useTranslation } from 'react-i18next';

import { ORDER_STATUSES } from 'constants/orderStatuses';

export const useOrderStatusBannerInfo = () => {
   const { t } = useTranslation();

   const ORDER_STATUS_BANNER_INFO: Record<string, string> = {
      [ORDER_STATUSES.WAITING]: t('orderStatusBanner.waiting'),
      [ORDER_STATUSES.IN_PROGRESS]: t('orderStatusBanner.inProgress'),
      [ORDER_STATUSES.DURING_BILLING]: t('orderStatusBanner.duringBilling'),
      [ORDER_STATUSES.TO_PAY]: t('orderStatusBanner.toPay'),
   };

   return { ORDER_STATUS_BANNER_INFO };
};
